import { render, staticRenderFns } from "./page14.vue?vue&type=template&id=4bdc5d38&scoped=true&"
import script from "./page14.vue?vue&type=script&lang=js&"
export * from "./page14.vue?vue&type=script&lang=js&"
import style0 from "./page14.vue?vue&type=style&index=0&id=4bdc5d38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc5d38",
  null
  
)

export default component.exports